import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../api";

export const doGetAllCompanies = createAsyncThunk("companies/doGetAllCompanies", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doGetAllCompanies(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doCreateCompany = createAsyncThunk("companies/doCreateCompany", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doCreateCompany(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doUpdateCompany = createAsyncThunk("companies/doUpdateCompany", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doUpdateCompany(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doGetAllPartnerCompanies = createAsyncThunk(
  "companies/doGetAllPartnerCompanies",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doGetAllPartnerCompanies(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);

export const doCreatePartnerCompany = createAsyncThunk("companies/doCreatePartnerCompany", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doCreatePartnerCompany(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doUpdatePartnerCompany = createAsyncThunk("companies/doUpdatePartnerCompany", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doUpdatePartnerCompany(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});
